export async function callApi(
    apiKey: string,
    url: string,
    method: string,
    body?: any,
    tries = 3
  ) {
    const headers = new Headers();
  
    headers.append("x-api-key", apiKey);
    const options = {
      method: method,
      headers: headers,
      ...(body && {
        body: body,
      }),
    };
    return fetch(url, options).then((response) => {
      if (!response.ok) {
        console.log(response.status)
        return response.json().then(errorResponse => {
          if (response.status === 500 && errorResponse.message === "Failed to resume database") {
            if (tries === 0) {
              throw new Error(JSON.stringify({
                status: response.status,
                message: errorResponse
              }));
            } else {
              return callApi(apiKey, url, method, body, tries - 1)
            }
          } else {
            throw new Error(JSON.stringify({
              status: response.status,
              message: errorResponse
            }));
          }
          
        })
      }
      return response.json()
    });
  }
  